export type SubMenuItem = {
  label: string
  hash: string
  disabled?: boolean
}
